"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const components_common_modals_1 = require("@hotelplan/components.common.modals");
const TravelRooms_1 = __importDefault(require("./TravelRooms"));
function TravelRoomsDropdown({ travelRooms, saveTravelRooms, configuration, isManualDistribution, close, show, side, dropdownRef, className, }) {
    return (react_1.default.createElement(components_common_modals_1.DropDownWrapper, { ref: dropdownRef, className: className },
        react_1.default.createElement(components_common_modals_1.AbsoluteDropdown, { isShown: show, side: side, className: "travel-rooms-dropdown" }, travelRooms && (react_1.default.createElement(TravelRooms_1.default, { saveTravelRooms: saveTravelRooms, closeTravelRooms: close, value: travelRooms, isManualDistribution: isManualDistribution, configuration: configuration })))));
}
exports.default = TravelRoomsDropdown;
//# sourceMappingURL=TravelRoomsDropdown.js.map